import { ISymbol } from "../../models/ISymbol";
import { SYMBOLS_SET_SYMBOLS } from "./symbols-types";

export const setSymbols = (symbols: ISymbol[]) => (dispatch: any) =>
  dispatch({ type: SYMBOLS_SET_SYMBOLS, payload: symbols });
